import { createSelector } from 'reselect';
import { redux } from 'Core/redux';
import { STORE_KEY, INITIAL_STATE } from './slice';

export const selectState = state => {
  const appState = state || redux.store.getState();
  return appState?.[STORE_KEY] || INITIAL_STATE;
};

export const selectMoldData = state => selectState(state).data;
export const selectMoldLoading = state => selectState(state).loading;
export const selectfetchMoldLoading = state => selectState(state).receivingLoading;
export const selectMoldReceivingError = state => selectState(state).error;
export const selectMoldFilterVisible = state => selectState(state).filterVisible;
export const selectMoldReceivingFilters = state => selectState(state).filters;
export const selectFilterVisible = state => selectState(state).filterVisible;
export const selectTileView = state => selectState(state).tileView;
export const selectFilteredMolds = createSelector(
  [selectMoldData, selectMoldReceivingFilters],
  (data, { searchText }) => {
    return data.filter(entry =>
      Object.keys(entry).some(key =>
        String(entry[key]).toLowerCase().includes(searchText.toLowerCase()),
      ),
    );
  },
);
